<template>
    <div class="pdfIcons">
        <button
            class="kgr-table__action"
            :disabled="disabled"
            style="position: relative;"
            @click="download()"
        >
            <kgr-icon
                :title="downloadTitle"
                :disabled="disabled"
                icon-class="pdf"
            />
            <i
                v-if="downloadedByUser"
                class="kgr-indicator is-success dot"
            >
            </i>
        </button>
        <button
            :disabled="disabled"
            @click="preview()"
        >
            <kgr-icon
                :title="previewTitle"
                :disabled="disabled"
                icon-class="preview"
            />
        </button>
    </div>
</template>
<script>
import ClubInvoiceDunningPdfRepository from '../../../js/repository/ClubInvoiceDunningPdfRepository.js';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon
    },
    props: {
        invoice: {
            type: Object,
            required: true,
        },
        dunningLevel: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
        }
    },
    computed: {
        iconColor() {
            return this.downloadedByMember ? 'green' : '';
        },
        disabled() {
            return !this.invoice.dunningPdfs[this.dunningLevel]['pdfExists'];
        },
        downloadTitle: function () {
            if (!this.invoice.dunningPdfs[this.dunningLevel]['pdfExists']) {
                return this.$t('Das PDF wird erstellt');
            }
            let title = this.$t('PDF herunterladen');
            if (this.downloadedByUser) {
                title = title + '\n\nLetzter Download von einem Mitarbeiter am ' + this.formatDate(this.invoice.dunningPdfs[this.dunningLevel]['lastDownload']);
            }
            if (this.downloadedByMember) {
                title = title + '\n\nLetzter Download vom Mitglied am ' + this.formatDate(this.invoice.dunningPdfs[this.dunningLevel]['lastDownloadByMember']);
            }
            return title
        },
        previewTitle: function () {
            if (!this.invoice.dunningPdfs[this.dunningLevel]['pdfExists']) {
                return this.$t('Das PDF wird erstellt');
            }
            return this.$t('PDF ansehen')
        },
        downloadedByUser() {
            return null !== this.invoice.dunningPdfs[this.dunningLevel]['lastDownload'];
        },
        downloadedByMember() {
            return null !== this.invoice.dunningPdfs[this.dunningLevel]['lastDownloadByMember'];
        }
    },
    methods: {
        download() {
            ClubInvoiceDunningPdfRepository.createDownloadHistory(this.invoice.id, this.dunningLevel)
                .then(response => {
                    ClubInvoiceDunningPdfRepository.downloadDunningPdf(response.headers.location)
                        .then(() => {
                            this.$emit('reloadInvoice');
                        })
                        .catch(() => this.$notify.error('error.loadingData'));
                });
        },
        formatDate(date) {
            return new Helper().formatDate(date);
        },
        preview() {
            ClubInvoiceDunningPdfRepository.createDownloadHistory(this.invoice.id, this.dunningLevel)
                .then(response => {
                    window.open(response.headers.location + '?contentDisposition=inline', '_blank');
                    this.$emit('reloadInvoice');
                });
        },
    },
}
</script>

<style>
    div.pdfIcons {
        margin-left: 15px;
    }
    .dot {
        height: 7px;
        width: 7px;
        background-color: #00ff00;
        border-radius: 50%;
        position: absolute;
        top: 0;
        right: 0;
    }
</style>
